<template>
    <jet-section>
        <template #title>
            Entries
        </template>
        <template #description>
            Here are your current and previous entries.
        </template>
        <template #content>
            <div class="overflow-scroll shadow border-b border-gray-200 transition duration-500 ease-in-out dark:border-gray-800 sm:rounded-lg" v-if="user.has_bets"
                 :class="user.bets.length > 7 ? 'h-96':''">
                <table class="min-w-full divide-y divide-gray-200 table-auto">
                    <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Winner
                            </th>
                            <th scope="col" class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Points
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Amount Won
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Placed On
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 ">
                        <tr v-for="(bet, betKey) in user.bets" :key="betKey" :class="betKey % 2 === 0 ? 'bg-white transition duration-500 ease-in-out dark:bg-gray-600' : 'bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-800'" class="dark:hover:bg-opacity-80">
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm  text-center text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    <RacingStarsIcon v-if="bet.amount > 0" class="inline-block h-6 w-6 text-green-500 transition duration-500 ease-in-out dark:text-racing-stars-yellow" />
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white text-center">
                                <div class="text-sm text-center font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                   {{ bet.points ? bet.points : 0 }}
                                </div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white"> {{ bet.amount ? "£"+ bet.amount / 100 : 0 }}</div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ moment(bet.created_at).format('dddd, MMMM Do, YYYY') }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <alert type="info" class="mt-4">
                    <template #title>
                        No Bets Available!
                    </template>
                    <template #message>
                        You haven't placed your first bet yet.
                    </template>
                </alert>
            </div>
        </template>
    </jet-section>
</template>
<script>
import { ref, computed } from 'vue'
import JetSection from '@/Jetstream/Section.vue'
import JetButton from '@/Jetstream/Button.vue'
import TwTable from '@/Global/Elements/TwTable.vue'
import TwButton from '@/Global/Elements/TwButton.vue'
import TwModal from '@/Global/Elements/TwModal.vue'
import ChangeSelection from '@/Global/ChangeSelection.vue'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import Alert from '@/Global/Alert.vue'
import moment from 'moment'
import { useStore } from 'vuex'
import { XIcon } from '@heroicons/vue/solid'

export default {
    components: {
        JetSection,
        JetButton,
        TwTable,
        TwModal,
        TwButton,
        RacingStarsIcon,
        Alert,
        ChangeSelection,
        XIcon,
    },

    props: {
        user: Object,
        races: Object,
    },

    setup(props) {
        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const store = useStore()

        const toggleRaceSelectionPopup = ref(false)

        const racesStillOpen = computed(() => {
            return props.races.some(e => moment(e.starts_at).subtract(2, 'minutes').isAfter(moment()))
        })

        const changeSelection = (race) => {
            toggleRaceSelectionPopup.value = !toggleRaceSelectionPopup.value

            store.commit('setRaceToModify', race)
            store.commit('toggleShowRunnerSelection')
        }

        return {
            formatter,
            moment,
            changeSelection,
            toggleRaceSelectionPopup,
            racesStillOpen,
        }
    }
}

</script>
